module.exports = __webpack_public_path__ + "static/pep-rally-2a8d0aa7ef3eb1753ff58ca64dd7dabf.png";